"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var optimizely_utils_exports = {};
__export(optimizely_utils_exports, {
  QueueOfFunctions: () => QueueOfFunctions,
  createOptimizelyDecisionErrorHandler: () => createOptimizelyDecisionErrorHandler,
  createOptimizelyDecisionNotificationHandler: () => createOptimizelyDecisionNotificationHandler,
  extractUserGroupFromDeviceId: () => extractUserGroupFromDeviceId,
  formatEventName: () => formatEventName,
  isBotUserAgent: () => isBotUserAgent
});
module.exports = __toCommonJS(optimizely_utils_exports);
var import_optimzely_types = require("./optimzely-types");
const formatEventName = (name) => (
  // Convert our format to Optimizely standard https://docs.developers.optimizely.com/feature-experimentation/docs/create-events
  name.toLowerCase().replaceAll(/\W+/g, "_")
);
class QueueOfFunctions {
  ready;
  queue;
  constructor() {
    this.queue = [];
    this.ready = false;
  }
  runWhenReady(fn) {
    if (this.ready) {
      fn();
      return;
    }
    this.queue.push(fn);
  }
  setAsReady = () => {
    if (this.ready) {
      return;
    }
    this.ready = true;
    this.queue.forEach((fn) => {
      fn();
    });
    this.queue = [];
  };
}
function createOptimizelyDecisionNotificationHandler(track) {
  const mapOfTrackedDecisions = /* @__PURE__ */ new Map();
  return function optimizelyDecisionNotificationHandler(decisionPayload) {
    const { decisionEventDispatched, flagKey, variationKey } = decisionPayload.decisionInfo;
    if (decisionEventDispatched === true && flagKey !== import_optimzely_types.Experiment.PERSISTENT_A_A && mapOfTrackedDecisions.get(flagKey) !== variationKey) {
      mapOfTrackedDecisions.set(flagKey, variationKey);
      track(
        "global.experiment_decision",
        decisionPayload
      );
    }
  };
}
function createOptimizelyDecisionErrorHandler(track) {
  const errorHandler = {
    trackError: (reason) => {
      track("global.experimentation_platform_error", {
        reason: reason ?? "not given"
      });
    },
    handleError: (error) => {
      errorHandler.trackError(error.message);
    }
  };
  return errorHandler;
}
const EXACT_PATTERN = /^(?:|mozilla\/5\.0|agent-probe|consumer_area)$/;
const STARTS_WITH_PATTERN = /^(?:axios|node|agent)/;
const CONTAINS_PATTERN = /(?:bot|googleimageproxy|googleother|externalhit|crawler)/;
const NOT_A_BOT_PATTERN = /cubot/i;
const combinedPatterns = [
  EXACT_PATTERN,
  STARTS_WITH_PATTERN,
  CONTAINS_PATTERN
].reduce(
  (acc, pattern) => acc ? `${acc}|${pattern.source}` : pattern.source,
  ""
);
const BOT_PATTERN = new RegExp(combinedPatterns, "i");
const isBotUserAgent = (userAgent) => {
  if (NOT_A_BOT_PATTERN.test(userAgent)) {
    return false;
  }
  return BOT_PATTERN.test(userAgent);
};
const extractUserGroupFromDeviceId = (deviceId) => {
  const lastInteger = deviceId.match(/(\d)(?!.*\d)/);
  const value = lastInteger ? parseInt(lastInteger[0], 10) : 0;
  return value;
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  QueueOfFunctions,
  createOptimizelyDecisionErrorHandler,
  createOptimizelyDecisionNotificationHandler,
  extractUserGroupFromDeviceId,
  formatEventName,
  isBotUserAgent
});
